module.exports = __webpack_public_path__ + "img/bcc.54f680d8.svg";